<template>
  <v-card class="pa-2">
    <v-tabs color="primary" grow>
      <v-tab>{{ $t("vesselActivities.grid") }}</v-tab>
      <v-tab>{{ $t("vesselActivities.weather") }}</v-tab>
      <v-tab>{{ $t("header.title3") }}</v-tab>
      <v-tab-item>
        <grid-activities></grid-activities>
      </v-tab-item>
      <v-tab-item>
        <v-container>
          <template>
            <v-data-table :headers="headers" :items="items" hide-default-footer class="elevation-0" disable-pagination>
              <template v-for="header in headers" v-slot:[`header.${header.value}`]>
                <v-tooltip bottom v-if="header.tooltip" :key="header.value">
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                      <span>{{ header.text }}</span>
                    </div>
                  </template>
                  <span>{{ header.tooltip }}</span>
                </v-tooltip>
                <span v-else :key="header.tooltip">{{ header.text }}</span>
              </template>
              <template slot="item" slot-scope="props">
                <tr>
                  <td style="text-align: left">{{ props.item.time }}</td>
                  <td style="text-align: left">{{ props.item.windDirection }}</td>
                  <td style="text-align: left">{{ props.item.windForce }}</td>
                  <td style="text-align: left">{{ props.item.seaDirection }}</td>
                  <td style="text-align: left">{{ props.item.seaHeight }}</td>
                  <td style="text-align: left">{{ props.item.visibility }}</td>
                  <td style="text-align: left">{{ props.item.airTemperature }}</td>
                  <td style="text-align: left">{{ props.item.waterTemperature }}</td>
                  <td style="text-align: left">{{ props.item.comments }}</td>
                  <td style="text-align: left">{{ props.item.surface }}</td>
                  <td style="text-align: left">{{ props.item.intensityAndDirection }}</td>
                  <td style="text-align: left">{{ props.item.tideReadings }}</td>
                </tr>
              </template>
            </v-data-table>
          </template>
        </v-container>
      </v-tab-item>

      <v-tab-item>
        <v-container class="mt-10">
          <v-row class="d-sm-flex d-md-table mx-auto">
            <v-row>
              <v-spacer></v-spacer>
              <v-col cols="3">
                <b>{{ this.$t("header.fuel") }}</b>
              </v-col>
              <v-col cols="3">
                <b>{{ $t("header.lubricant") }}</b>
              </v-col>
              <v-col cols="3">
                <b>{{ this.$t("header.freshWater") }}</b>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3" class="text-center">
                <b>{{ this.$t("header.available") }}</b>
              </v-col>
              <v-col cols="3">
                <v-text-field readonly v-model="dprHeader.availFuel"></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field readonly v-model="dprHeader.availLubricant"></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field readonly v-model="dprHeader.availWater"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3" class="text-center">
                <b>{{ this.$t("header.bunkered") }}</b>
              </v-col>
              <v-col cols="3">
                <v-text-field readonly v-model="dprHeader.bunkFuel"></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field readonly v-model="dprHeader.bunkLubricant"></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field readonly v-model="dprHeader.bunkWater"></v-text-field>
              </v-col>
            </v-row>
          </v-row>
        </v-container>
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>
<script>
import { mapMutations, mapGetters, mapActions } from "vuex";
import GridActivities from "./GridActivities";

export default {
  components: { GridActivities },
  data() {
    return {
      headers: [
        {
          text: this.$t("vessel.localTime"),
          align: "start",
          value: "time",
          tooltip: this.$t("tooltip.localTime"),
        },
        { text: this.$t("vessel.windDirection"), value: "windDirection", tooltip: this.$t("tooltip.windDirection") },
        { text: this.$t("vessel.windForce"), value: "windForce", tooltip: this.$t("tooltip.windForce") },
        { text: this.$t("vessel.seaDirection"), value: "seaDirection", tooltip: this.$t("tooltip.seaDirection") },
        { text: this.$t("vessel.seaHeight"), value: "seaHeight", tooltip: this.$t("tooltip.seaHeight") },
        { text: this.$t("vessel.visibility"), value: "visibility", tooltip: this.$t("tooltip.visibility") },
        { text: this.$t("vessel.airTemp"), value: "airTemperature", tooltip: this.$t("tooltip.airTemp") },
        { text: this.$t("vessel.waterTemp"), value: "waterTemperature", tooltip: this.$t("tooltip.waterTemp") },
        { text: this.$t("vessel.comments"), value: "comments", tooltip: this.$t("tooltip.comments") },
        { text: this.$t("vessel.surface"), value: "surface", tooltip: this.$t("tooltip.surface") },
        {
          text: this.$t("vessel.intensityAndDirection"),
          value: "intensityAndDirection",
          tooltip: this.$t("tooltip.intensityAndDirection"),
        },
        { text: this.$t("vessel.tideReadings"), value: "tideReadings", tooltip: this.$t("tooltip.tideReadings") },
      ],

      currentMainDprId: null,
      currentPVId: null,
      dprHeader: {
        availFuel: null,
        availLubricant: null,
        availWater: null,
        bunkFuel: null,
        bunkLubricant: null,
        bunkWater: null,
      },
    };
  },

  computed: {
    ...mapGetters(["mv_dprData/getDprPVId", "mv_dprHeader/getCoords", "mv_weather/getWeather"]),
    formTitle() {
      return this.editedIndex === -1 ? this.$t("common.new") + " " + this.$t("vessel.weather") : this.$t("common.edit") + " " + this.$t("vessel.weather");
    },
    coordinates() {
      return this["mv_dprHeader/getCoords"];
    },
    items() {
      return this["mv_weather/getWeather"];
    },
  },
  created() {
    this.currentMainDprId = this.$route.params.dprMainId;
    this.currentPVId = this.$route.params.pvId;

    this["mv_dprHeader/fetchCoords"]();
    this["mv_weather/fetchWeatherEntries"](this.currentMainDprId);
    this.$log.debug("loading activities and weather for DPR", this.currentMainDprId, "within PV", this.currentPVId);

    this["mv_dprHeader/fetchDprHeader"](this.currentMainDprId).then((dprheader) => (this.dprHeader = dprheader));
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.mHideLongLoader();
    });
  },
  methods: {
    ...mapMutations(["mHideLongLoader"]),
    ...mapActions(["loadUserContext", "mv_dprHeader/fetchCoords", "mv_dprHeader/fetchDprHeader", "mv_weather/fetchWeatherEntries"]),
  },
};
</script>
<style scoped>
.container {
  max-width: 95%;
}
</style>
